import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(list: any, searchText: string): SafeHtml {

    if (!list) { return []; }
    if (!searchText) { return list; }
    const replaceText = searchText.charAt(0).toUpperCase() + searchText.slice(1);
    const reg = new RegExp('(' + searchText + ')', 'gi');
    const value = list.replace(
      reg, `<span><b><i>${replaceText}</i></b></span>`);
    console.log('highlight value', value);
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
